import React from 'react';
import { ContainerComponent } from "./components/ContainerComponent";
import HelpComponent from './components/HelpComponent'


export interface AppProps {
  params: any;
}
class App extends React.Component<AppProps, {}> {
  getParamValue(paramName: string): any {
    const normalizedParams = Object.entries(this.props.params).reduce((acc, [key, value]) => {
      acc[key.toLowerCase()] = value;
      return acc;
    }, {} as Record<string, any>);

    return normalizedParams[paramName.toLowerCase()];
  }

  paramExists(paramName: string): boolean {
    return Object.keys(this.props.params).some(key => key.toLowerCase() === paramName.toLowerCase());
  }

  render() {
    console.log(this.props.params);

    const { params } = this.props;
    const hasParams = Object.keys(params).length > 0;

    return (
      <div className="App">
        {hasParams ? (
          <ContainerComponent
            extId={this.props.params["extid"] !== undefined ? this.props.params["extid"] : this.props.params["extId"]}
            product={this.props.params["product"]}
            direction={this.props.params["direction"]}
            line={this.props.params["line"]}
            platform={this.props.params["track"]}
            displayTrack={this.props.params["displayTrack"]}
            token={this.props.params["token"]}
            showRealtime={this.props.params["showRealtime"]}
            trackRequest={this.props.params["trackRequest"]}
            isArrivalBoard={this.paramExists("isarrivalboard")}
          />
        ) : (
          <HelpComponent />
        )}
      </div>
    );
  }
}
export default App;
